import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Switch, Route, } from 'react-router-dom';
import { FirebaseAppProvider } from 'reactfire';
import firebaseConfig from '../firebaseConfig';
import Footer from './organims/Footer';
import Header from './organims/Header';
import ContactUs from './pages/ContactUs';
import Home from './pages/Home';
import Projects from './pages/Projects';
import store from './redux/store';

const App=()=>(
  <FirebaseAppProvider firebaseConfig={firebaseConfig}>
    <Provider store={store}>
    <Router>
    <Header />
    <Switch>
      <Route path='/contacto' exact component={ContactUs}/>
      <Route path='/proyectos' exact component={Projects}/>
      <Route path='/' exact component={Home}/>
    </Switch>
    <Footer />
  </Router>
  </Provider>
  </FirebaseAppProvider>
)

export default App;
